import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getWebsiteLanguage = createAsyncThunk('WebsiteLanguage/data/getWebsiteLanguage', async (data) => {
    const language = 'sq'
    return language
})

const dataSlice = createSlice({
    name: 'WebsiteLanguage/data',
    initialState: {
        language: '',
        scrollTo: '',
        Resources: [],
        ActiveResource: [],
        GeneralTranslations: [],
        AlertTranslations: [],
        ControlsTranslations: [],
        ValidationTranslations: [],
        ContentTranslations: [],
        Instuticionet: [],
        Komentet: [],
        ReferenceId: null,
        RaportStatusId: null,
    },
    reducers: {
        setWebLanguage: (state, action) => {
            state.language = action.payload;
        },
        setScrollTo: (state, action) => {
            state.scrollTo = action.payload;
        },
        setResources: (state, action) => {
            state.Resources = action.payload;
        },
        setActiveResource: (state, action) => {
            state.ActiveResource = action.payload;
        },
        setGeneralTranslations: (state, action) => {
            state.GeneralTranslations = action.payload;
        },
        setAlertTranslations: (state, action) => {
            state.AlertTranslations = action.payload;
        },
        setControlsTranslations: (state, action) => {
            state.ControlsTranslations = action.payload;
        },
        setValidationTranslations: (state, action) => {
            state.ValidationTranslations = action.payload;
        },
        setContentTranslations: (state, action) => {
            state.ContentTranslations = action.payload;
        },
        setInstutucionet: (state, action) => {
            state.Instuticionet = action.payload;
        },
        setKomentet: (state, action) => {
            state.Komentet = action.payload;
        },
        setReferenceId: (state, action) => {
            state.ReferenceId = action.payload;
        },
        setRaportStatusId: (state, action) => {
            state.RaportStatusId = action.payload;
        },
    },
    extraReducers: {
        [getWebsiteLanguage.fulfilled]: (state, action) => {
            state.language = action.payload
            state.scrollTo = ''
        },
    }
});

export const {
    setWebLanguage,
    setScrollTo,
    setResources,
    setActiveResource,
    setGeneralTranslations,
    setAlertTranslations,
    setControlsTranslations,
    setValidationTranslations,
    setContentTranslations,
    setInstutucionet,
    setKomentet,
    setReferenceId,
    setRaportStatusId
} = dataSlice.actions;

export default dataSlice.reducer;
